// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__Vr+mW","spin":"Spinner_spin__oi2GC"};